var React = require('react');

function TickCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.357 5.285L6.967 8.679L5.612 7.321C5.237 6.946 4.631 6.946 4.256 7.321C3.882 7.696 3.882 8.303 4.256 8.678L6.29 10.714C6.664 11.089 7.271 11.089 7.646 10.714L11.713 6.642C12.087 6.267 12.087 5.659 11.713 5.285C11.34 4.91 10.732 4.91 10.357 5.285ZM8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM8 14C4.687 14 2 11.313 2 8C2 4.687 4.687 2 8 2C11.313 2 14 4.687 14 8C14 11.313 11.313 14 8 14Z","fill":"black"}));
}

TickCircle.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = TickCircle;

TickCircle.default = TickCircle;
